var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Players } from "../../modules/players";
// Define vue parameters
var EditPlayerComponent = /** @class */ (function (_super) {
    __extends(EditPlayerComponent, _super);
    /**
     * Setup the child and parent class
     */
    function EditPlayerComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.players = new Players();
        return _this;
    }
    /**
     * Component setup on mount
     */
    EditPlayerComponent.prototype.mounted = function () {
        var _this = this;
        this.players.get().then(function (r) {
            _this.$data.playerData = r;
        });
    };
    /**
     * Update a players account
     */
    EditPlayerComponent.prototype.updatePlayer = function () {
        this.players
            .update(this.$refs.firstName.value, this.$refs.lastName.value, this.$refs.isMale.value, this.$refs.securityType.value, this.$refs.password.value)
            .then(function (r) {
            alert("Your account has been updated");
        });
    };
    EditPlayerComponent = __decorate([
        Component({
            data: function () {
                return {
                    playerData: null
                };
            }
        })
        // Define the component code
    ], EditPlayerComponent);
    return EditPlayerComponent;
}(Vue));
export default EditPlayerComponent;
